import SniptripApp from './SniptripApp';

function App() {
  return (
    <div className="App">
      <SniptripApp />
    </div>
  );
}

export default App;
